import FormDropdown from "../Dropdown";

const yearRange = (title, startYear, endYear) => {
	const years = [title];
	for (let year = startYear; year <= endYear; year++) {
		years.push(String(year));
	}
	return years;
};

const currentYear = new Date().getFullYear();

export const GradYears = yearRange(
	"HS Grad Year",
	currentYear - 4,
	currentYear + 15,
);
const childBirthYears = yearRange("Year", currentYear - 20, currentYear);
export const adultBirthYears = yearRange(
	"Year",
	currentYear - 100,
	currentYear - 16,
);

export const DOBSelect = ({
	month,
	setMonth,
	day,
	setDay,
	year,
	setYear,
	yearOptions = childBirthYears,
}) => {
	return (
		<div className="flex flex-wrap gap-3">
			<div className="min-w-[11rem] flex-1">
				<FormDropdown
					options={[
						"Month",
						"January",
						"February",
						"March",
						"April",
						"May",
						"June",
						"July",
						"August",
						"September",
						"October",
						"November",
						"December",
					]}
					value={month}
					setVal={setMonth}
				/>
			</div>
			<div className="w-24">
				<FormDropdown
					options={[
						"Day",
						"1",
						"2",
						"3",
						"4",
						"5",
						"6",
						"7",
						"8",
						"9",
						"10",
						"11",
						"12",
						"13",
						"14",
						"15",
						"16",
						"17",
						"18",
						"19",
						"20",
						"21",
						"22",
						"23",
						"24",
						"25",
						"26",
						"27",
						"28",
						"29",
						"30",
						"31",
					]}
					value={day}
					setVal={setDay}
				/>
			</div>
			<div className="w-32">
				<FormDropdown options={yearOptions} value={year} setVal={setYear} />
			</div>
		</div>
	);
};

export const Height = ({ feet, setFeet, inches, setInches }) => {
	return (
		<div className="flex flex-wrap gap-3">
			<div className="w-32">
				<FormDropdown
					options={["Height (ft)", "4", "5", "6", "7"]}
					value={feet}
					setVal={setFeet}
				/>
			</div>
			<div className="w-36">
				<FormDropdown
					options={[
						"Height (in)",
						"0",
						"1",
						"2",
						"3",
						"4",
						"5",
						"6",
						"7",
						"8",
						"9",
						"10",
						"11",
					]}
					value={inches}
					setVal={setInches}
				/>
			</div>
		</div>
	);
};

export const SchoolOptions = [
	"Wrightstown Ridge",
	"Wilson",
	"Walden Grove",
	"Wakefield",
	"Veritas Academy",
	"Valencia",
	"Vail Innovation Center",
	"Vail Academy",
	"Utterback",
	"University",
	"Twin Peaks",
	"Tucson",
	"Tucson Waldorf",
	"Tucson Hebrew Academy",
	"Tortolita",
	"The Gregory School",
	"Tanque Verde",
	"Sunnyside",
	"Star Academic",
	"St. Michael",
	"St. Joseph",
	"St. John",
	"St. Cyril",
	"St. Augustine",
	"St. Ambrose",
	"Sierra",
	"Sentinel Peak",
	"Secrist",
	"Santa Rita",
	"Salpointe",
	"Sahuarita",
	"Sahuaro",
	"Sabino",
	"Roskruge",
	"Robins",
	"Roberts-Naylor",
	"Rincon",
	"Rincon Vista",
	"Rattlesnake Ridge",
	"Pusch Ridge",
	"Pueblo",
	"Pueblo Gardens",
	"Pistor",
	"Palo Verde",
	"Our Mother of Sorrows",
	"Orange Grove",
	"Old Vail",
	"Mountain View",
	"Morgan Maxwell",
	"Miles Exploratory",
	"Mica Mountain",
	"Mary Meredith",
	"Mary Belle McCorkle",
	"Marana",
	"Marana Middle",
	"Mansfeld Middle",
	"Magee",
	"Leman",
	"Lawrence",
	"Lauffer",
	"La Cima",
	"Legacy",
	"Ironwood Ridge",
	"Imago Dei",
	"International School of Tucson",
	"Homeschool",
	"Hollinger",
	"Gridley",
	"Gallego",
	"Flowing Wells",
	"First Southern",
	"Faith Lutheran",
	"Faith Community Academy",
	"Esperero Canyon",
	"Esmond Station",
	"Empire",
	"Emily Gray",
	"Drachman",
	"Dove Mountain",
	"Doolen",
	"Dodge",
	"Dietz",
	"Desert View",
	"Desert Sky",
	"Desert Christian",
	"Cross",
	"Coronado",
	"Corona Foothills",
	"Civano",
	"Cienega",
	"Cholla",
	"Challenger",
	"Catalina",
	"Catalina Foothills",
	"Casas",
	"Canyon Del Oro",
	"Calvary Chapel",
	"C.E. Rose",
	"Borman",
	"Booth-Fickett",
	"BASIS",
	"Aqua Caliente",
	"Apollo",
	"Anza Trail School",
	"Andrada Polytechnic",
	"Amphitheater",
	"Altar Valley",
	"Alice Vail",
	"Academy Del Sol",
].map((s) => {
	return { value: s, label: s };
});
